import ActDomainForm from 'civil-status/components/domain-management/form';
import { DetailActDomainManagmentCrumbs } from 'civil-status/constants/breadcrumb';
import { memo, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse, NewHttpResponseList } from 'shell/models/http-response';
import { transformActDomain } from '../utils/transform-act-domain';
import { ActDomainManagement } from 'shell/models/act-domain-management';

import { ValueDomainType } from 'shell/models/value-domain-type';
import { transformActDomainTypeValues } from '../utils/transform-act-domain-type-values';
import { transformDataset } from 'civil-status/components/domain-management/utils';
import { ActDomainFormVM } from 'civil-status/view-models/act-domain-form';
import {
  ActValueDomainResponseVM,
  ActValueDomainVM,
} from 'civil-status/view-models/act-value-domain-managment-list';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useUserProfile } from 'shell/hooks/use-user-profile';
const DetailActManagementPage = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/stato-civile/ricerca-dominio');
  };

  const [actDomain] = useHttpFetch<HttpResponse<ActDomainManagement>, ActDomainFormVM>(
    `${__ACT_API_URL__}/tipo-dominio-atti/${params?.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformActDomain,
    }
  );

  const [valuesDomain, getValuesDomain] = useHttpFetch<
    NewHttpResponseList<ValueDomainType>,
    ActValueDomainResponseVM
  >(`${__ACT_API_URL__}/valori-dominio-atti`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformActDomainTypeValues,
  });

  const { userProfile } = useUserProfile();

  const valuesDomainList = useMemo(() => {
    return ((valuesDomain?.data as ActValueDomainResponseVM)?.valuesDomain ||
      []) as Array<ActValueDomainVM>;
  }, [valuesDomain?.data]);

  useEffect(() => {
    if (params?.id) {
      const queryString = transformDataset({ actDomainId: params?.id, withoutPagination: true });
      getValuesDomain({
        params: {},
        paramsSerializer: () => queryString,
      });
    }
  }, [params?.id]);

  const initialValues: ActDomainFormVM = useMemo(() => {
    const actDomainData = (actDomain?.data || {}) as ActDomainFormVM;
    return {
      ...actDomainData,
      actDomainValues: valuesDomainList,
      entityBody: actDomainData?.entityBody || userProfile.datiLogin?.key?.codiceEnte,
    };
  }, [actDomain?.data, valuesDomainList, userProfile?.datiLogin]);

  const valuesDomainListCount = useMemo(() => {
    return (valuesDomain?.data as ActValueDomainResponseVM)?.pageInfo?.totalCount || 0;
  }, [valuesDomain?.data]);

  return (
    <>
      <Breadcrumbs items={DetailActDomainManagmentCrumbs} />
      <ActDomainForm
        title="Visualizzazione dominio"
        disabled
        onCancel={onCancel}
        isForDetail
        valuesDomainListCount={valuesDomainListCount}
        initialValues={initialValues}
      />
    </>
  );
};

DetailActManagementPage.displayName = 'Detail Act Management Page';
const ActDomainDetailManagementPage = memo(DetailActManagementPage);
export default ActDomainDetailManagementPage;
